import { Col, Row, Space, Tabs } from "antd";
import { Package, Layers } from "lucide-react";
import { HeaderSupplies } from "./header-supplies";
import { OverviewSupplies } from "./overview-supplies";
import { SidebarSupplies } from "./sidebar-supplies";
import { VendorManagement } from "./vendor-management";
import { ModalSupply } from "./modal-supplies";
import { TableSupplies } from "./list";
import { ListSupplyKits } from "../supply-kits/list-supply-kits";

export const ListSupplies = () => {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <HeaderSupplies />

      <Tabs
        defaultActiveKey="supplies"
        size="large"
        items={[
          {
            key: "supplies",
            label: (
              <span className="flex items-center gap-2">
                <Package size={18} />
                Supplies
              </span>
            ),
            children: (
              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <OverviewSupplies />
                <Row gutter={24}>
                  <Col span={6}>
                    <SidebarSupplies />
                  </Col>
                  <Col span={18}>
                    <TableSupplies />
                  </Col>
                </Row>
                <VendorManagement />
              </Space>
            ),
          },
          {
            key: "kits",
            label: (
              <span className="flex items-center gap-2">
                <Layers size={18} />
                Kits
              </span>
            ),
            children: <ListSupplyKits />,
          },
        ]}
      />

      <ModalSupply />
    </Space>
  );
};
